
import Typography from '@mui/material/Typography';


export const TextDrugCarbamazepine = () => {

return(
<div>
    
<Typography variant="h6" >
<br />


Carbamazepine is used alone or in combination with other medications to control certain types of seizures in people with epilepsy. 
It is also used to treat trigeminal neuralgia (a condition that causes facial nerve pain). Carbamazepine extended-release capsules 
(Equetro brand only) are also used to treat episodes of mania (frenzied, abnormally excited or irritated mood) or mixed episodes 
(symptoms of mania and depression that happen at the same time) in patients with bipolar I disorder (manic-depressive disorder; 
a disease that causes episodes of depression, episodes of mania, and other abnormal moods). Carbamazepine is in a class of medications called anticonvulsants. 
It works by reducing abnormal electrical activity in the brain.
<br /><br />


Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a682237.html

</Typography>

</div>

)
}